import { useEffect, useRef } from "react";

/**
 * a replica of useEffect, except the callback will not be run when mounting
 * the component, only when one of the tracked dependencies changes
 */
export function useChangeEffect(cb: () => void, deps: unknown[]): void {
  const isMountingRef = useRef(true);

  useEffect(
    () => {
      // bail out while we're mounting the component, so only actual changes
      // are emitted
      if (isMountingRef.current) {
        // We await in a timeout to ensure that React strictmode has a chance
        // to fire twice before marking the component as fully mounted.
        setTimeout(() => {
          isMountingRef.current = false;
        });
        return;
      }

      cb();
    },
    // we intentionally only trigger the callback whenever one of the tracked
    // dependencies have changed
    // eslint-disable-next-line react-hooks/exhaustive-deps
    deps,
  );
}
